import Vue from "vue";
import Router from "vue-router";
import LoginRegisterView from "@/views/LoginRegisterView.vue";
import HomeView from "@/views/HomeView.vue";
import ChatView from "@/views/ChatView.vue";
import CompanionListView from "@/views/CompanionListView.vue";
import CompanionEditorView from "@/views/CompanionEditorView.vue";
import CompanionDetailView from "@/views/CompanionDetailView.vue";
import PricingView from "@/views/PricingView.vue";
import ProfileView from "@/views/ProfileView.vue";
import RoleCardsView from "@/views/RoleCardsView.vue";
import ImageStudioView from "@/views/ImageStudioView.vue";
import WechatAccountsView from "@/views/WechatAccountsView.vue";
import SharedConversationsView from "@/views/SharedConversationsView.vue";
import AdminView from "@/views/AdminView.vue";
import AdminOrdersView from "@/views/AdminOrdersView.vue";
import PromptAdminView from "@/views/PromptAdminView.vue";
import ShareLandingView from "@/views/ShareLandingView.vue";

import { getToken, getUser } from "@/services/api";

Vue.use(Router);

if (window.location.hash.startsWith("#/")) {
  window.history.replaceState(null, "", window.location.hash.slice(1));
}

const router = new Router({
  mode: "history",
  routes: [
    { path: "/", name: "home", component: HomeView },
    { path: "/home", redirect: "/" },
    { path: "/login", name: "login", component: LoginRegisterView },
    { path: "/reset-password", name: "reset-password", component: LoginRegisterView },
    { path: "/chat", name: "chat", component: ChatView },
    { path: "/companions", name: "companions", component: CompanionListView },
    { path: "/companion-editor", name: "companion-editor", component: CompanionEditorView },
    { path: "/role-card-editor", name: "role-card-editor", component: CompanionEditorView },
    { path: "/companion-detail", name: "companion-detail", component: CompanionDetailView },
    { path: "/role-cards", name: "role-cards", component: RoleCardsView },
    { path: "/image-studio", name: "image-studio", component: ImageStudioView },
    { path: "/wechat-accounts", name: "wechat-accounts", component: WechatAccountsView },
    { path: "/shared-conversations", name: "shared-conversations", component: SharedConversationsView },
    { path: "/pricing", name: "pricing", component: PricingView },
    { path: "/profile", name: "profile", component: ProfileView },
    { path: "/admin", name: "admin", component: AdminView, meta: { requiresAdmin: true } },
    { path: "/admin/orders", name: "admin-orders", component: AdminOrdersView, meta: { requiresAdmin: true } },
    { path: "/admin/prompts", name: "admin-prompts", component: PromptAdminView, meta: { requiresAdmin: true } },
    { path: "/share/:token", name: "share", component: ShareLandingView },
  ],
});

const PUBLIC = ["login", "reset-password", "share", "home"];

router.beforeEach((to, from, next) => {
  if (to.name === "login" && getToken()) return next({ name: "chat" });
  if (PUBLIC.includes(to.name)) return next();
  if (!getToken()) return next({ name: "login" });
  if (to.matched.some((record) => record.meta && record.meta.requiresAdmin)) {
    const u = getUser();
    if (!u || !u.is_admin) return next({ name: "chat" });
  }
  next();
});

export default router;
